function Disconnect() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5909 21.1818C6.57 21.1818 2.5 17.1118 2.5 12.0909C2.5 7.07 6.57 3 11.5909 3C13.0024 2.99894 14.3947 3.32707 15.6572 3.95831C16.9197 4.58956 18.0176 5.50653 18.8636 6.63637H16.4C15.3502 5.71069 14.0556 5.1076 12.6716 4.89946C11.2875 4.69131 9.87279 4.88696 8.59717 5.46292C7.32155 6.03889 6.23923 6.97069 5.48006 8.14654C4.7209 9.32238 4.31715 10.6923 4.31727 12.0919C4.31739 13.4915 4.72136 14.8614 5.48072 16.0371C6.24008 17.2128 7.32256 18.1445 8.59827 18.7202C9.87399 19.2959 11.2887 19.4914 12.6728 19.283C14.0568 19.0746 15.3513 18.4713 16.4009 17.5455H18.8645C18.0184 18.6754 16.9204 19.5925 15.6577 20.2237C14.3951 20.855 13.0026 21.183 11.5909 21.1818ZM17.9545 15.7273V13H10.6818V11.1818H17.9545V8.45455L22.5 12.0909L17.9545 15.7273Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Disconnect;
